export default __webpack_public_path__ + "static/media/vic_3.988ed78d.jpg";